// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"798":"4f1b8d8c8a7e4ac4","1655":"13e67eccbc4f430b"}[chunkId] + ".js";
};